// extracted by mini-css-extract-plugin
export var wrap = "Page404-module--wrap--1gO6a";
export var inner = "Page404-module--inner--1y_kW";
export var text = "Page404-module--text--3JF7S";
export var link = "Page404-module--link--QZRU4";